//GeneratorFlag:[NoChange]
import VirtualFolder from './virtual-folder';

export default {VirtualFolder}
export{VirtualFolder}